export default "__VITE_ASSET__Ci22YO8Z__"